import { ActionTree } from 'vuex';
import { IEntry } from '../types/entry';
import {
  EDocumentChangelogAction,
  EDocumentChangelogMutation,
} from './document-changelog.constants';
import { IDocumentChangelogState } from './document-changelog.types';
import { RootState } from '@/store/store';

export const actions: ActionTree<IDocumentChangelogState, RootState> = {
  [EDocumentChangelogAction.AddEntry](
    { commit },
    { documentId, entry }: { documentId: string; entry: IEntry }
  ) {
    commit(EDocumentChangelogMutation.AddEntry, { documentId, entry });
  },

  [EDocumentChangelogAction.DeletePost]({ commit }, documentId: string) {
    commit(EDocumentChangelogMutation.DeletePost, documentId);
  },
};
